import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiPaper']
>['styleOverrides'] = {
  root: ({ theme }) => ({
    boxShadow: theme.vars.shadows[1],
  }),
};

const MuiPaper: Components<CssVarsTheme>['MuiPaper'] = {
  styleOverrides,
};

export default MuiPaper;
